import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../App";
import { action, controller, Server } from "../../../../api/Server";
import { Grid } from "@mui/material";
import { Button } from "../../../../controls";
import { RandomCode } from "../../../../hooks/Method";

const PaymentType = ({ setValues, receiveAmt, receiveAmtRef }) => {
  const [methods, setMethods] = useState([]);
  const { authUser, loader } = useContext(AppContext);

  const handleFocusAmt = () => {
    if (receiveAmtRef.current !== null) {
      receiveAmtRef.current.focus();
      receiveAmtRef.current.select();
    }
  };

  useEffect(() => {
    Server(controller.PayMethod + action.GetActiveMethods).get((res) => {
      if (res && res.status === 200) {
        var result = res.result;
        setMethods([...result.map((j) => ({ ...j, label: j.title }))]);
        handleFocusAmt();
      }
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handlePayment = (method) => {
    if (parseFloat(receiveAmt) > 0) {
      setValues((prev) => ({
        ...prev,
        payments: [
          {
            key: RandomCode(15),
            payMethodId: method.id,
            amount: receiveAmt,
            methodTitle: method.label,
          },
          ...prev.payments,
        ],
      }));
      setTimeout(() => {
        handleFocusAmt();
      }, 50);
    }
  };

  return (
    <>
      {methods.map((method, ind) => (
        <Grid key={ind} item xs={12} md={4}>
          <Button
            disabled={loader}
            onClick={() => handlePayment(method)}
            fullWidth
            size="large"
            sx={{
              height: "100%",
              lineHeight: "1.4",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <div className="d-grid">
              <span className="fs-18">{method.title}</span>
              <span className="fs-12">{method.subtitle}</span>
            </div>
          </Button>
        </Grid>
      ))}
    </>
  );
};

export default PaymentType;
